import {
  MonitorReducerStateType,
  MonitorStorageActions,
  Types,
} from './Monitor.types';
import {
  createInitialBundleInfoStatusList,
  sortBundlesBySortSettings,
  sortBundlesByStatus,
  updateBundlesInfoStatusList,
} from '../../../utils/bundlesMonitorUtils';
import _ from 'lodash';

export const monitorStorageReducer = (
  state: MonitorReducerStateType,
  action: MonitorStorageActions
): MonitorReducerStateType => {
  switch (action.type) {
    case Types.DeleteBundle: {
      console.log('action', action, state);
      const { bundleId } = action.payload;
      const updatedBundles = state.bundles.filter(
        bundle => bundle.id !== bundleId
      );
      const updatedBundleInfoStatus = { ...state.bundlesInfoStatus };
      delete updatedBundleInfoStatus[bundleId];
      const updatedOrders = { ...state.orders };
      delete updatedOrders[bundleId];
      return {
        ...state,
        bundles: updatedBundles,
        bundlesInfoStatus: updatedBundleInfoStatus,
        orders: updatedOrders,
      };
    }
    case Types.AddNewBundle: {
      console.log('action', action, state);
      const { bundles, orders } = action.payload;
      let updatedBundles = [...state.bundles];
      updatedBundles.push(...bundles);
      const infoStatusOfNewBundles = createInitialBundleInfoStatusList(bundles);
      const updatedBundleInfoStatus = { ...state.bundlesInfoStatus };
      Object.keys(infoStatusOfNewBundles).forEach(
        key => (updatedBundleInfoStatus[key] = infoStatusOfNewBundles[key])
      );
      const updatedOrders = { ...state.orders };
      Object.keys(orders).forEach(key => (updatedOrders[key] = orders[key]));
      if (!state.sortKey && !state.autoSort) {
        const { sortedBundles } = sortBundlesBySortSettings(
          updatedBundles,
          updatedBundleInfoStatus,
          'bundles',
          'bundles',
          updatedOrders
        );
        updatedBundles = sortedBundles;
      } else if (!state.sortKey && state.autoSort) {
        updatedBundles = sortBundlesByStatus(
          updatedBundles,
          updatedBundleInfoStatus
        );
      } else if (state.sortKey) {
        const { sortedBundles } = sortBundlesBySortSettings(
          updatedBundles,
          updatedBundleInfoStatus,
          state.sortKey,
          state.sortType === 'asc' ? '' : state.sortKey,
          updatedOrders
        );
        updatedBundles = sortedBundles;
      }
      return {
        ...state,
        bundles: updatedBundles,
        bundlesInfoStatus: updatedBundleInfoStatus,
        orders: updatedOrders,
      };
    }
    case Types.SetLoading: {
      console.log('action', action, state);
      const { loading } = action.payload;
      return {
        ...state,
        loading,
      };
    }
    case Types.StoreAllFetchedData: {
      console.log('action', action, state);
      const {
        bundles,
        orders,
        couriers,
        bundlesInfoStatus,
        loading,
        autoSort,
      } = action.payload;
      return {
        ...state,
        bundles,
        orders,
        couriers,
        bundlesInfoStatus,
        loading,
        autoSort,
      };
    }
    case Types.UpdateBundlesInfoStatus: {
      console.log('action', action, state);
      const { bundlesInfoStatus } = action.payload;
      return {
        ...state,
        bundlesInfoStatus,
      };
    }
    case Types.UpdateBundlesInfoStatusAndSortBundles: {
      console.log('action', action, state);
      const { bundlesInfoStatus, bundles } = action.payload;
      return {
        ...state,
        bundles,
        bundlesInfoStatus,
      };
    }
    case Types.UpdateSelectedBundle: {
      console.log('action', action, state);
      const { bundles, bundleId, order } = action.payload;
      const updatedBundlesInfoStatus = updateBundlesInfoStatusList(
        bundles,
        state.bundlesInfoStatus
      );
      const bundle = bundles[0];
      const updatedBundles = [...state.bundles].map(currentBundle =>
        currentBundle.id === bundle.id ? bundle : currentBundle
      );
      return {
        ...state,
        bundles: updatedBundles,
        orders: {
          ...state.orders,
          [bundleId]: order,
        },
        bundlesInfoStatus: updatedBundlesInfoStatus,
      };
    }
    case Types.UpdateSelectedBundles: {
      console.log('action', action, state);
      const { bundles, orders } = action.payload;
      const updatedBundlesInfoStatus = updateBundlesInfoStatusList(
        bundles,
        state.bundlesInfoStatus
      );
      const updatedBundles = [...state.bundles].map(currentBundle => {
        const bundleToSwap = bundles.find(
          updatedBundle => updatedBundle.id === currentBundle.id
        );
        return bundleToSwap || currentBundle;
      });
      return {
        ...state,
        bundles: updatedBundles,
        orders: {
          ...state.orders,
          ...orders,
        },
        bundlesInfoStatus: updatedBundlesInfoStatus,
      };
    }
    case Types.SetLoadingForBundle: {
      console.log('action', action, state);
      const { bundleId, bundlesLoadingStatus } = action.payload;
      if (state.bundlesInfoStatus.hasOwnProperty(bundleId)) {
        return {
          ...state,
          bundlesInfoStatus: {
            ...state.bundlesInfoStatus,
            [bundleId]: {
              ...state.bundlesInfoStatus[bundleId],
              loading: bundlesLoadingStatus,
            },
          },
        };
      }
      return state;
    }
    case Types.StoreLastChangesInBundle: {
      console.log('action', action, state);
      const {
        bundleId,
        view = 'normal',
        selectedOrders = [],
        draftOrderList = [],
      } = action.payload;
      const currentBundleInfoStatus = state.bundlesInfoStatus[bundleId];
      if (
        currentBundleInfoStatus.view === view &&
        _.isEqual(currentBundleInfoStatus.selectedOrders, selectedOrders) &&
        _.isEqual(currentBundleInfoStatus.draftOrderList, draftOrderList)
      ) {
        return state;
      }
      return {
        ...state,
        bundlesInfoStatus: {
          ...state.bundlesInfoStatus,
          [bundleId]: {
            ...state.bundlesInfoStatus[bundleId],
            view,
            selectedOrders,
            draftOrderList,
          },
        },
      };
    }
    case Types.ToggleCollapseOrTableView: {
      console.log('action', action, state);
      const { bundleId, type } = action.payload;
      if (type === 'collapse') {
        return {
          ...state,
          bundlesInfoStatus: {
            ...state.bundlesInfoStatus,
            [bundleId]: {
              ...state.bundlesInfoStatus[bundleId],
              collapseOpen: !state.bundlesInfoStatus[bundleId].collapseOpen,
              tablePickupsOpen: state.bundlesInfoStatus[bundleId].collapseOpen
                ? false
                : state.bundlesInfoStatus[bundleId].tablePickupsOpen,
            },
          },
        };
      } else {
        return {
          ...state,
          bundlesInfoStatus: {
            ...state.bundlesInfoStatus,
            [bundleId]: {
              ...state.bundlesInfoStatus[bundleId],
              tablePickupsOpen:
                !state.bundlesInfoStatus[bundleId].tablePickupsOpen,
            },
          },
        };
      }
    }
    case Types.CollapseAll: {
      console.log('action', action, state);
      const { bundleIdsToClose } = action.payload;
      const copyBundleInfoStatus = { ...state.bundlesInfoStatus };
      bundleIdsToClose.forEach(bundleId => {
        copyBundleInfoStatus[bundleId] = {
          ...copyBundleInfoStatus[bundleId],
          tablePickupsOpen: false,
          collapseOpen: false,
        };
      });
      return { ...state, bundlesInfoStatus: copyBundleInfoStatus };
    }
    case Types.SetLoadingForBundles: {
      console.log('action', action, state);
      const { bundleIds, bundlesLoadingStatus } = action.payload;
      const filteredListOfIds = bundleIds.filter(id =>
        state.bundlesInfoStatus.hasOwnProperty(id)
      );
      const copyBundleInfoStatus = { ...state.bundlesInfoStatus };
      filteredListOfIds.forEach(id => {
        copyBundleInfoStatus[id] = {
          ...copyBundleInfoStatus[id],
          loading: bundlesLoadingStatus,
        };
      });
      return {
        ...state,
        bundlesInfoStatus: copyBundleInfoStatus,
      };
    }
    case Types.SetSortByKey: {
      console.log('action', action);
      const { sortKey } = action.payload;
      const currentSortKey = state.sortKey;
      const currentSortType = state.sortType;
      const { sortedBundles, sortType } = sortBundlesBySortSettings(
        state.bundles,
        state.bundlesInfoStatus,
        currentSortType === 'desc' && currentSortKey === sortKey ? '' : sortKey,
        currentSortKey,
        state.orders
      );
      if (
        currentSortType === 'desc' &&
        currentSortKey === sortKey &&
        sortKey === 'bundles'
      ) {
        return {
          ...state,
          sortKey: sortType === '' ? '' : sortKey,
          sortType,
          autoSort: sortType !== '',
        };
      }
      return {
        ...state,
        bundles: sortedBundles,
        sortKey: sortType === '' ? '' : sortKey,
        sortType,
        autoSort: sortType !== '',
      };
    }
    case Types.SetAutoSort: {
      console.log('action', action, state);
      const { autoSort } = action.payload;
      if (state.sortKey === '' && autoSort) {
        const updatedBundlesInfoStatus = updateBundlesInfoStatusList(
          state.bundles,
          state.bundlesInfoStatus
        );
        const bundlesSortedByDelays = sortBundlesByStatus(
          state.bundles,
          updatedBundlesInfoStatus
        );

        return {
          ...state,
          bundles: bundlesSortedByDelays,
          bundlesInfoStatus: updatedBundlesInfoStatus,
          autoSort,
        };
      } else if (state.sortKey === '' && !autoSort) {
        const { sortedBundles } = sortBundlesBySortSettings(
          state.bundles,
          state.bundlesInfoStatus,
          state.sortKey,
          state.sortKey,
          state.orders
        );
        return {
          ...state,
          bundles: sortedBundles,
          autoSort,
        };
      } else {
        return {
          ...state,
          autoSort,
        };
      }
    }
    default:
      console.log('action', action);
      return state;
  }
};
